import client from './client'
import { AxiosPromise } from 'axios'
import { BasicResult, RPUnit, Medication } from '../types/models/Presc'

export type ReportBasicResultParams = {
  prescId: string
  key: keyof BasicResult
  isReported: boolean
}

export type ReportRPUnitParams = {
  prescId: string
  rpNum: number
  key: keyof RPUnit
  isReported: boolean
}

export type ReportMedicationParams = {
  prescId: string
  rpNum: number
  rpNumSub: number
  key: keyof Medication
  isReported: boolean
}

export type ReportRPIndexParams = {
  prescId: string
  rpNum: number
  isReported: boolean
}

export type ReportMedShortageParams = {
  prescId: string
  ocrErrorLabel: string
}

export const postBasicResultReport = ({
  prescId,
  key,
  isReported,
}: ReportBasicResultParams): AxiosPromise => {
  const params = { isReported }
  return client.post(`prescriptions/${prescId}/basic_results/${key}/`, params)
}

export const postRPUnitReport = ({
  prescId,
  rpNum,
  key,
  isReported,
}: ReportRPUnitParams): AxiosPromise => {
  const params = { isReported }
  return client.post(
    `prescriptions/${prescId}/med_results/${rpNum}/${key}/`,
    params
  )
}

export const postMedicationReport = ({
  prescId,
  rpNum,
  rpNumSub,
  key,
  isReported,
}: ReportMedicationParams): AxiosPromise => {
  const params = { isReported }
  return client.post(
    `prescriptions/${prescId}/med_results/${rpNum}/${rpNumSub}/${key}/`,
    params
  )
}

export const postRPIndexReport = ({
  prescId,
  rpNum,
  isReported,
}: ReportRPIndexParams): AxiosPromise => {
  const params = { isReported }
  return client.post(`prescriptions/${prescId}/med_results/${rpNum}/`, params)
}

export const postMedResultShortage = ({
  prescId,
  ocrErrorLabel,
}: ReportMedShortageParams): AxiosPromise => {
  return client.post(`prescriptions/${prescId}/med_results/ocr_error/`, {
    label: ocrErrorLabel,
  })
}

export type PostPrescFeedbackParams = {
  prescId: string
  note: string
}

/**
 * 改善依頼 (文章 1 欄)。⚑ の項目・当社の出力・QR・Request ID・店舗・ユーザは back が
 * 持っているので、送るのは文章だけ。Kakeru君 の `…/<request_id>/feedback/` と同じ形。
 */
export const postPrescFeedback = ({
  prescId,
  note,
}: PostPrescFeedbackParams): AxiosPromise =>
  client.post(`prescriptions/${prescId}/feedback/`, { note })
